import React from 'react';
import { LinkIcon, ShieldCheckIcon } from 'lucide-react';
import { PageHeader } from '../../components/PageHeader';
import { Icon, serviceGlyph } from '../../components/icons/Icon';
import { Card } from '../../components/ui/Card';
import { autoInputSources } from '../../data/engagement';
import { connectedServices } from '../../data/settings';
import { useLocale } from '../../contexts/LocaleContext';

/**
 * MOB/Settings/ConnectedServices — prepared for future integrations only.
 * No provider is active; each is labelled "Em breve" / "Coming soon".
 */
export function ConnectedServices() {
  const {
    t,
    tl
  } = useLocale();
  return <div className="px-2 pb-2" data-id="element-3626" data-mp="1astgz712iura">
      <PageHeader title={t('settings.services')} subtitle={t('services.subtitle')} showBack data-id="element-3627" data-mp="1avo63bv113r1" />

      <Card className="p-2" data-id="element-3628" data-mp="3vj0zv2uodz2g">
        <p className="text-[12px] leading-snug text-muted" data-id="element-3629" data-mp="3virb1ild9xyc">{t('services.note')}</p>
      </Card>

      <ul className="mt-2 rounded-card border border-sand-line bg-white/70 px-2" data-id="element-3630" data-mp="4e0yovfzplwy">
        {connectedServices.map(service => <li key={service.id} className="flex items-center gap-2 border-b border-sand-line py-2 last:border-b-0" data-id="element-3631" data-mp="1um5aw2uyxbvz">
            <span className="grid h-10 w-10 shrink-0 place-items-center rounded-[13px] bg-sand-deep text-soft" data-id="element-3632" data-mp="24iiblkoxkq08">
              <Icon name={serviceGlyph[service.id] ?? 'connection'} size="md" data-id="element-3633" data-mp="1zichlxv6urez" />
            </span>
            <span className="min-w-0 flex-1" data-id="element-3634" data-mp="2dhvflxuacmdk">
              <span className="block text-[13.5px] font-medium text-deep" data-id="element-3635" data-mp="2dgkanup3t8kv">
                {service.label ? tl(service.label) : service.name}
              </span>
              <span className="mt-[2px] block text-[11.5px] leading-snug text-muted" data-id="element-3636" data-mp="2n86swazv07x4">
                {tl(service.description)}
              </span>
              <span className="mt-[2px] block text-[10.5px] leading-snug text-soft" data-id="element-3637" data-mp="2w950125lgvjx">
                {t('services.planned')}:{' '}
                {service.capabilities.map(capability => t(`services.cap.${capability}`)).join(' · ')}
              </span>
            </span>
            <span className="bee-overline shrink-0 rounded-pill border border-sand-line px-2 py-[4px] text-[8.5px] font-bold text-muted" data-id="element-3638" data-mp="349ks9ilb567h">
              {t('services.comingSoon')}
            </span>
          </li>)}
      </ul>

      <section className="mt-3" aria-labelledby="auto-input-title" data-id="element-3639" data-mp="3e0p263w4m0vg">
        <h2 id="auto-input-title" className="px-1 text-[14px] font-bold text-deep" data-id="element-3640" data-mp="3i20p21nm87zy">
          {t('eng.auto.title')}
        </h2>
        <p className="mt-[2px] px-1 text-[12px] leading-snug text-muted" data-id="element-3641" data-mp="3mzan25p2lrze">{t('eng.auto.body')}</p>
        <ul className="mt-2 rounded-card border border-sand-line bg-white/70 px-2" data-id="element-3642" data-mp="3s0zwjgwn9xld">
          {autoInputSources.map(source => <li key={source.habit} className="flex items-center gap-2 border-b border-sand-line py-2 last:border-b-0" data-id="element-3643" data-mp="r17t28vf4n8">
              <span className="min-w-0 flex-1" data-id="element-3644" data-mp="22ljns2mmudw0">
                <span className="block text-[13px] font-medium text-deep" data-id="element-3645" data-mp="jpm73tz5muwj">
                  {t(`habit.${source.habit === 'mindfulness' ? 'mind' : source.habit}.title`)}
                </span>
                <span className="mt-[2px] block text-[11px] leading-snug text-muted" data-id="element-3646" data-mp="ex2twy4dq1s9">
                  {tl(source.signal)} · {t('eng.auto.from', {
                providers: source.providers.join(', ')
              })}
                </span>
              </span>
              <span className="bee-overline shrink-0 rounded-pill border border-sand-line px-2 py-[4px] text-[8.5px] font-bold text-muted" data-id="element-3647" data-mp="12ort8yfmbqip">
                {t('services.comingSoon')}
              </span>
            </li>)}
        </ul>
        <p className="mt-2 px-1 text-[11px] leading-snug text-soft" data-id="element-3648" data-mp="tlz2cwaclgte">{t('eng.auto.confirm')}</p>
      </section>

      <Card className="mt-2 p-2" data-id="element-3649" data-mp="oqtj658byg90">
        <p className="flex items-start gap-1 text-[12px] leading-snug text-deep" data-id="element-3650" data-mp="3eekdkt793j8f">
          <ShieldCheckIcon size={15} className="mt-[1px] shrink-0 text-soft" aria-hidden="true" data-id="element-3651" data-mp="39ey1wo72mb1q" />
          <span data-id="element-3652" data-mp="1169pltujizxj">{t('services.privacy')}</span>
        </p>
      </Card>

      <p className="mt-2 px-1 text-[11px] leading-snug text-muted" data-id="element-3653" data-mp="114yhxixz5815">
        {t('services.futureNote')}
      </p>
    </div>;
}